export default __webpack_public_path__ + "static/media/video_icon.ea79d40b.svg";